import React, {
    useEffect, useState,
} from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import GridItem from '../../components/Grid/GridItem';
import GridContainer from '../../components/Grid/GridContainer';
import CustomTypography from '../../components/Typography/CustomTypography';
import DetailSeminarStyle from '../../assets/jss/pages/detailSeminarCompanyStyle';
import Button from '../../components/Button/CustomButton';
import FormDialog from '../../components/Dialog/FormDialog';
import CustomTextSelector from '../../selectors/CustomText';

const useStyles = makeStyles(DetailSeminarStyle);

const DialogDetailLiveStreamOrganizer = (props) => {
    const {
        isOpen,
        handleClose,
        detailEvent,
        detailLiveStreamId,
        eventName,
        handleOpenEdit,
        fetchClearDetailLiveStream,
        fetchGetDetailLiveStream,
        eventInfo,
    } = props;
    const classes = useStyles();
    const [params, setParams] = useState({});
    const intl = useIntl();
    const customText = useSelector(CustomTextSelector.createGetCustomText());

    useEffect(() => {
        fetchClearDetailLiveStream();
        return () => {
            fetchClearDetailLiveStream();
        };
    }, []);

    useEffect(() => {
        if (isOpen) {
            fetchGetDetailLiveStream({ event_name: eventName, live_stream_id: detailLiveStreamId });
        }
    }, [isOpen]);

    useEffect(() => {
        if (detailEvent) setParams({ ...detailEvent });
    }, [detailEvent]);

    const actionsButton = () => (
        <Box style={{ margin: 'auto' }}>
            <Button
                autoFocus
                gradient
                onClick={handleOpenEdit}
                size="md"
                color="success"
                className={classes.btn}
                style={{ width: '200px', fontSize: '20px', left: ' 20%' }}
            >
                編集する
            </Button>
            <Button
                autoFocus
                gradient
                onClick={handleClose}
                size="md"
                color="danger"
                style={{ width: '150px', marginRight: '10px', left: ' 80%' }}
            >
                {intl.formatMessage({ id: 'cancel' })}
            </Button>
        </Box>
    );

    return (
        <>
            <FormDialog
                isOpen={isOpen}
                handleClose={handleClose}
                title={(
                    <Box>
                        <CustomTypography variant="h6" bold color="info">
                            {customText?.content?.screen_name?.livestream_info || 'ライブ配信情報'}
                        </CustomTypography>
                    </Box>
                )}
                actions={actionsButton()}
            >
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} sm={3} md={3}>
                        <CustomTypography bold>
                            {!_.isEmpty(eventInfo.languages)
                                ? `${customText?.content?.field_name?.title || 'タイトル'}（和文）`
                                : (customText?.content?.field_name?.title || 'タイトル')}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={9} md={9}>
                        <CustomTypography bold>
                            {params.title}
                        </CustomTypography>
                    </GridItem>
                </GridContainer>
                {!_.isEmpty(eventInfo.languages) && (
                    <GridContainer className={classes.spacing}>
                        <GridItem xs={12} sm={3} md={3}>
                            <CustomTypography bold>
                                {`${customText?.content?.field_name?.title || 'タイトル'}（英文）`}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={9} md={9}>
                            <CustomTypography bold>
                                {params.title_en}
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>
                )}
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} sm={3} md={3}>
                        <CustomTypography bold>
                            {!_.isEmpty(eventInfo.languages)
                                ? `${customText?.content?.field_name?.performer || '出演者'}（和文）`
                                : (customText?.content?.field_name?.performer || '出演者')}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={9} md={9}>
                        <CustomTypography bold>
                            {params.speaker}
                        </CustomTypography>
                    </GridItem>
                </GridContainer>
                {!_.isEmpty(eventInfo.languages) && (
                    <GridContainer className={classes.spacing}>
                        <GridItem xs={12} sm={3} md={3}>
                            <CustomTypography bold>
                                {`${customText?.content?.field_name?.performer || '出演者'}（英文）`}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={9} md={9}>
                            <CustomTypography bold>
                                {params.speaker_en}
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>
                )}
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} sm={3} md={3}>
                        <CustomTypography bold>
                            {customText?.content?.field_name?.dates || '日程'}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={9} md={9}>
                        {
                            (params.dates || []).map((date) => (
                                <CustomTypography bold>
                                    {[date.date.slice(0, 4), '/', date.date.slice(5, 7), '/', date.date.slice(8, 10)].join('')}
                                </CustomTypography>
                            ))
                        }
                    </GridItem>
                </GridContainer>
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} sm={3} md={3}>
                        <CustomTypography bold>
                            {customText?.content?.field_name?.time_zone || '時間帯'}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={9} md={9}>
                        <CustomTypography bold>
                            {params.stime}
                            {' '}
                            ~
                            {' '}
                            {params.etime}
                        </CustomTypography>
                    </GridItem>
                </GridContainer>
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} sm={3} md={3}>
                        <CustomTypography bold>
                            {customText?.content?.field_name?.performer_profile || '出演者プロフィール'}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={9} md={9}>
                        <CustomTypography bold>
                            {params.streamer_profile}
                        </CustomTypography>
                    </GridItem>
                </GridContainer>
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} sm={3} md={3}>
                        <CustomTypography bold>
                            {!_.isEmpty(eventInfo.languages)
                                ? `${customText?.content?.field_name?.contents || '配信内容'}（和文）`
                                : (customText?.content?.field_name?.contents || '配信内容')}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={9} md={9}>
                        <CustomTypography bold>
                            {params.content}
                        </CustomTypography>
                    </GridItem>
                </GridContainer>
                {!_.isEmpty(eventInfo.languages) && (
                    <GridContainer className={classes.spacing}>
                        <GridItem xs={12} sm={3} md={3}>
                            <CustomTypography bold>
                                {`${customText?.content?.field_name?.contents || '配信内容'}（英文）`}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={9} md={9}>
                            <CustomTypography bold>
                                {params.content_en}
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>
                )}
                {
                    !eventInfo.free_live_stream && eventInfo.has_shopping_cart && (
                        <GridContainer className={classes.spacing}>
                            <GridItem xs={12} sm={3} md={3}>
                                <CustomTypography bold>
                                    {customText?.content?.field_name?.maximum_number_applicants || '申込最大人数'}
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={9} md={9}>
                                {
                                    !(params.limit === -1) ? (
                                        <CustomTypography bold>
                                            {params.limit}
                                            {' '}
                                            人
                                        </CustomTypography>
                                    ) : (
                                        <CustomTypography bold>
                                            {intl.formatMessage({ id: 'noLimit' })}
                                        </CustomTypography>
                                    )
                                }
                            </GridItem>
                        </GridContainer>
                    )
                }
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} sm={3} md={3}>
                        <CustomTypography bold>
                            {customText?.content?.field_name?.information || '資料'}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={9} md={9}>
                        <CustomTypography bold>
                            {params.document}
                        </CustomTypography>
                    </GridItem>
                </GridContainer>
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} sm={3} md={3}>
                        <CustomTypography bold>
                            {customText?.content?.field_name?.document_request_reception || '資料請求受付'}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={9} md={9}>
                        <CustomTypography bold>
                            {params.document_link}
                        </CustomTypography>
                    </GridItem>
                </GridContainer>
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} sm={3} md={3}>
                        <CustomTypography bold>
                            {customText?.content?.field_name?.questionnaire || 'アンケート'}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={9} md={9}>
                        <CustomTypography bold>
                            {params.survey_link}
                        </CustomTypography>
                    </GridItem>
                </GridContainer>
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} sm={3} md={3}>
                        <CustomTypography bold>
                            {customText?.content?.field_name?.inquiries || 'お問合せ'}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={9} md={9}>
                        <CustomTypography bold>
                            {params.inquiry}
                        </CustomTypography>
                    </GridItem>
                </GridContainer>
                {!eventInfo.free_live_stream && eventInfo.has_shopping_cart && (
                    <GridContainer className={classes.spacing}>
                        <GridItem xs={12} sm={3} md={3}>
                            <CustomTypography bold>
                                {customText?.content?.field_name?.fee || '料金'}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={9} md={9}>
                            <CustomTypography bold>
                                {params.cost === 0 ? '無料' : `${intl.formatNumber(params.cost)}円`}
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>
                )}
            </FormDialog>
        </>
    );
};

DialogDetailLiveStreamOrganizer.defaultProps = {
    isOpen: false,
    handleOpenEdit: false,
    detailLiveStreamId: null,
    eventName: '',
    detailEvent: { },
    eventInfo: {},
};

DialogDetailLiveStreamOrganizer.propTypes = {
    isOpen: PropTypes.bool,
    handleOpenEdit: PropTypes.bool,
    handleClose: PropTypes.func.isRequired,
    detailLiveStreamId: PropTypes.number,
    eventName: PropTypes.string,
    fetchGetDetailLiveStream: PropTypes.func.isRequired,
    fetchClearDetailLiveStream: PropTypes.func.isRequired,
    detailEvent: PropTypes.oneOfType([() => null, PropTypes.object]),
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
};

export default DialogDetailLiveStreamOrganizer;
